<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <v-card class="mb-4" v-if="list_access">
      <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
        <div class="col-md-12">
          <div class="col-md-12" style="background: white">
            <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
            <v-divider class="mt-0"></v-divider>

            <div class="row pt-2">
              <div class="col-md-3">
                <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="hasta" :disabled="disabled"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacen" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-combobox v-model="filters.operario" density="comfortable" item-title="name" item-value="id" :items="operarios" label="Operario" autocomplete="off" clearable></v-combobox>
              </div>
              <div class="col-md-3">
                <v-select v-model="filters.task_type" density="comfortable" item-title="name" item-value="id" :items="task_type_options" label="Tipo de Tarea"></v-select>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="filters.idle_threshold_minutes" density="comfortable" type="number" min="1" max="1440" name="idle_threshold_minutes" label="Umbral inactividad (min)"></v-text-field>
              </div>

              <div class="col-md-6 pt-2 pb-2" style="display: flex; align-items: center; justify-content: end">
                <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
                <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="list_access">
      <v-card-title>
        <v-row align="center" class="mt-1">
          <v-col>
            <span>{{ page_title }}</span>
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" variant="text" size="small" icon class="ml-2" aria-label="Cómo leer este reporte" @click="dialog_info = true">
                  <v-icon color="grey">mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>Cómo leer este reporte</span>
            </v-tooltip>
          </v-col>
          <v-spacer></v-spacer>
          <v-col>
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table :headers="headers" :items="list" :search="search" :custom-filter="searchFilter" :loading="loading" loading-text="Cargando...">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.fecha }}</td>
            <td>{{ item.operario }}</td>
            <td class="text-center">
              <div>{{ item.tareas }}</div>
              <span class="text-caption text-grey-600 d-block">P {{ item.tareas_picking }} · G {{ item.tareas_guardado }} · T {{ item.tareas_transferencia }}</span>
            </td>
            <td class="text-center">
              <div>{{ item.unidades }}</div>
              <span class="text-caption text-grey-600 d-block">{{ hasValor(item.unidades_hora) ? item.unidades_hora + " u/h" : "-" }}</span>
            </td>
            <td class="text-center">
              <div>{{ formatUtils.formatSeconds(item.ritmo_mediana_seg) }}</div>
              <span class="text-caption text-grey-600 d-block" v-if="item.ritmo_muestras">prom. {{ formatUtils.formatSeconds(item.ritmo_promedio_seg) }} · {{ formatMuestras(item.ritmo_muestras) }}</span>
            </td>
            <td class="text-center">
              <div>{{ item.ordenes_empaquetadas }} emp</div>
              <span class="text-caption text-grey-600 d-block">{{ item.ordenes_expedidas }} exp</span>
            </td>
            <td>
              <div class="nowrap">{{ formatUtils.formatHora(item.primera_actividad) }} → {{ formatUtils.formatHora(item.ultima_actividad) }}</div>
              <span class="text-caption text-grey-600 d-block">{{ formatUtils.formatSeconds(item.span_seg) }}</span>
            </td>
            <td class="text-center">
              <div v-if="hasValor(item.activo_seg)">
                <v-chip size="x-small" variant="tonal" color="green" class="d-block mb-1">{{ formatUtils.formatSeconds(item.activo_seg) }}</v-chip>
              </div>
              <div v-if="hasValor(item.inactivo_seg)">
                <v-chip size="x-small" variant="tonal" color="orange" class="d-block">{{ formatUtils.formatSeconds(item.inactivo_seg) }}</v-chip>
              </div>
              <span v-if="!hasValor(item.activo_seg) && !hasValor(item.inactivo_seg)">-</span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <DialogInfo :dialog="dialog_info" title="Cómo leer este reporte" @updateDialog="dialog_info = $event">
      <div class="pt-4">
        <p class="text-h6 mb-1">¿Cómo se mide el tiempo?</p>
        <v-divider class="mb-3"></v-divider>
        <p class="text-body-2 mb-2">El tiempo por tarea es el intervalo entre una tarea terminada y la siguiente. Mide el ritmo real de trabajo en el depósito: incluye caminar hasta la ubicación, buscar el producto y escanear.</p>
        <p class="text-body-2 mb-2"><b>Sirve para</b> comparar operarios entre sí y ver si alguien mejora o empeora con el tiempo.</p>
        <p class="text-body-2 mb-4"><b>Es una medida de ritmo, no un cronómetro</b>, así que conviene leerla en comparación y en tendencia, más que como un tiempo objetivo por tarea.</p>

        <p class="text-h6 mb-1">El umbral de inactividad</p>
        <v-divider class="mb-3"></v-divider>
        <v-alert type="info" variant="tonal" density="compact" class="text-body-2 mb-4">
          Si un operario tarda 40 minutos entre dos tareas, no fue una tarea lenta: se fue a almorzar. El umbral que está arriba (por defecto 30 minutos) define a partir de cuánto un hueco deja de contar como trabajo y pasa a contar como pausa. Podés cambiarlo y ver cómo se mueven los números.
        </v-alert>

        <p class="text-h6 mb-1">Las columnas</p>
        <v-divider class="mb-3"></v-divider>
        <div class="text-body-2">
          <div class="mb-3">
            <span class="font-weight-bold">Tareas</span> —
            <span class="text-grey-600">Tareas terminadas del tipo que elegiste arriba. Abajo, en gris, cuántas hizo de cada tipo: P picking, G guardado, T transferencia. Ese desglose muestra siempre los tres, sin importar el filtro, para que veas todo lo que hizo la persona.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Unidades</span> —
            <span class="text-grey-600">Unidades pickeadas. Abajo, unidades por hora: es el número más justo para comparar operarios, porque una tarea de 200 unidades y una de 2 no son lo mismo. Solo el picking cuenta unidades; si filtrás guardado o transferencia va a dar 0.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Tiempo por tarea</span> —
            <span class="text-grey-600">Cuánto tarda habitualmente. Usamos la mediana y no el promedio: si tuvo dos o tres huecos largos, el promedio se dispara y deja de representar su día. El número grande es el que conviene comparar entre personas. Abajo está el promedio y la cantidad de mediciones: si dice 5 mediciones, tomalo con pinzas; con 160 el dato es sólido.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Expedición</span> —
            <span class="text-grey-600">Órdenes que empaquetó y que expidió. Este dato no depende del filtro de tipo de tarea.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Jornada</span> —
            <span class="text-grey-600">Del primer al último movimiento del día, y cuánto pasó entre los dos. No es horario de entrada y salida: arranca con la primera tarea terminada.</span>
          </div>
          <div class="mb-3">
            <span class="font-weight-bold">Activo / Inactivo</span> —
            <span class="text-grey-600">En verde, el tiempo trabajando. En naranja, los huecos. Siempre suman la jornada completa.</span>
          </div>
        </div>
      </div>
    </DialogInfo>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { reportsService } from "@/libs/ws/reportsService";
import { almacenService } from "@/libs/ws/almacenService";
import { employeeService } from "@/libs/ws/employeeService";
import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      service: reportsService,
      page_title: "Productividad por Operario",
      userTypeConstant: UserTypeConstant,
      user_type: null,
      dialog_info: false,
      formatUtils: formatUtils,
      headers: [
        { title: "Fecha", align: "left", sortable: true, value: "fecha", width: "100px", visible: true },
        { title: "Operario", align: "left", sortable: true, value: "operario", width: "170px", visible: true },
        { title: "Tareas", align: "center", sortable: true, value: "tareas", width: "130px", visible: true },
        { title: "Unidades", align: "center", sortable: true, value: "unidades", width: "120px", visible: true },
        { title: "Tiempo por tarea", align: "center", sortable: true, value: "ritmo_mediana_seg", width: "160px", visible: true },
        { title: "Expedición", align: "center", sortable: true, value: "ordenes_empaquetadas", width: "120px", visible: true },
        { title: "Jornada", align: "left", sortable: true, value: "primera_actividad", width: "170px", visible: true },
        { title: "Activo / Inactivo", align: "center", sortable: true, value: "activo_seg", width: "140px", visible: true },
      ],
      task_type_options: [
        { id: "PREPARACION", name: "Picking" },
        { id: "GUARDADO", name: "Guardado" },
        { id: "TRANSFERENCIA", name: "Transferencia" },
        { id: "ALL", name: "Todos" },
      ],
      filters: {
        date_from: new Date(
          new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        almacen: null,
        operario: null,
        task_type: "PREPARACION",
        idle_threshold_minutes: 30,
      },

      almacenes: [],
      operarios: [],
    };
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadOperarios();
  },
  methods: {
    hasValor(v) {
      return v !== null && v !== undefined && v !== "";
    },
    formatMuestras(n) {
      const v = Number(n) || 0;
      return v === 1 ? "1 medición" : v + " mediciones";
    },
    searchFilter(value, query, item) {
      const q = (query || "").toString().toLowerCase();
      if (!q) return true;
      const fields = ["fecha", "operario"];
      return fields.some((f) => (item.raw[f] || "").toString().toLowerCase().includes(q)) ? true : -1;
    },
    loadOperarios() {
      employeeService
        .filter_users({})
        .then((response) => {
          this.operarios = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadOperarios error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.loadAlmacenes error");
          console.log(e);
        });
    },
    getFilterParams() {
      return {
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        almacen: this.filters.almacen,
        operario: this.filters.operario ? { id: this.filters.operario.id } : null,
        task_type: this.filters.task_type || "PREPARACION",
        idle_threshold_minutes: this.filters.idle_threshold_minutes,
      };
    },
    loadList(service, param = null) {
      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      reportsService
        .productividad_operario(param)
        .then((response) => {
          if (!response.status) {
            this.toast.error(response.msg);
          }
          this.list = response.status ? response.result : [];
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.productividad_operario error");
          console.log(e);
          this.loading = false;
        });
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    exportFile() {
      var param = { ...this.getFilterParams() };
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/productividad-operario", param, "ProductividadOperario.xlsx");
    },
  },
};
</script>
